<template>
  <div class="d-flex flex-column flex-root">
    <div class="page d-flex flex-row flex-column-fluid">

      <div id="kt_aside" class="aside pb-5 pt-5 pt-lg-0" data-kt-drawer="true" data-kt-drawer-name="aside"
           data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true"
           data-kt-drawer-width="{default:'80px', '300px': '100px'}" data-kt-drawer-direction="start"
           data-kt-drawer-toggle="#kt_aside_mobile_toggle">
        <div class="aside-logo py-8" id="kt_aside_logo" style="height: 60px">
          <a href="#" class="d-flex align-items-center">
            <img alt="Logo" :src="require('@/assets/images/logo_ubbi_white.png')" class="h-60px logo"/>
          </a>
        </div>
        <div class="aside-menu flex-column-fluid" id="kt_aside_menu">

          <div class="hover-scroll-overlay-y my-2 my-lg-5 pe-lg-n1" id="kt_aside_menu_wrapper" data-kt-scroll="true"
               data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
               data-kt-scroll-wrappers="#kt_aside, #kt_aside_menu" data-kt-scroll-offset="5px">

            <Menu />
          </div>

        </div>
      </div>

      <div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">

        <Header />

        <div
          v-if="impersonationActive"
          class="alert alert-warning d-flex align-items-center justify-content-center rounded-0 mb-0 py-3 px-4 border-0"
          role="alert"
        >
          <i class="bi bi-shield-exclamation me-2"></i>
          <span>
            Modo suporte: você está acessando como <strong>{{ userAuth.user_name }}</strong>
            <span v-if="userAuth.impersonation?.admin_name">
              (iniciado por {{ userAuth.impersonation.admin_name }})
            </span>
          </span>
        </div>

        <div class="content d-flex flex-column flex-column-fluid" id="kt_content" style="padding: 0">
          <div id="kt_content_container">
            <router-view />
          </div>
        </div>

        <BannerModal v-if="place && userAuth" />

        <ModalMissingPlatformSubscription
          v-if="place"
          ref="missingSubscriptionModal"
          :place-name="place.place_name"
          :place-id="place.id_place"
        />

        <div class="footer py-4 d-flex flex-lg-column" id="kt_footer">
          <div class="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between">
            <div class="text-dark order-2 order-md-1">
              <span class="text-muted fw-bold me-1">{{ new Date().getFullYear() }}©</span>
              <a href="#" target="_blank" class="text-gray-800 text-hover-primary">Ubbimed</a>
            </div>
            <ul class="menu menu-gray-600 menu-hover-primary fw-bold order-1">
              <li class="menu-item">
                <a href="#" target="_blank" class="menu-link px-2">Início</a>
              </li>
              <li class="menu-item">
                <a href="#" target="_blank" class="menu-link px-2">Sobre</a>
              </li>
              <li class="menu-item">
                <a href="#" target="_blank" class="menu-link px-2">Suporte</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tracker from '@openreplay/tracker'
import { applyAuthenticatedBodyShell } from '../../../helpers/authShell';
import Header from "./Header";
import Menu from "./Menu";
import BannerModal from "./BannerModal";
import ModalMissingPlatformSubscription from "../../ModalMissingPlatformSubscription.vue";
import { isMissingPlatformSubscription } from "../../../helpers/platformSubscription";

export default {
  name: "Professional",
  components: {
    Header,
    Menu,
    BannerModal,
    ModalMissingPlatformSubscription,
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    userAuth() {
      return this.$store.state.auth.user;
    },
    impersonationActive() {
      return this.userAuth?.impersonation?.active === true;
    },
  },
  mounted() {
    applyAuthenticatedBodyShell();

    if (this.place?.id_place) {
      this.$store.dispatch('auth/refreshEntitlements').then(() => {
        this.showMissingSubscriptionModalIfNeeded();
      });
    }

    const tracker = new Tracker({
      projectKey: "q79uC4Qg7rYpiqVpRdmQ",
      defaultInputMode: 2,
    })

    tracker.setUserID(this.userAuth.user_name)
    if (this.place) {
      tracker.setMetadata('place', this.place.place_name)
      tracker.setMetadata('id_place', this.place.id_place)
    }

    tracker.start()
  },
  methods: {
    showMissingSubscriptionModalIfNeeded() {
      if (!isMissingPlatformSubscription()) {
        return;
      }

      this.$nextTick(() => {
        this.$refs.missingSubscriptionModal?.open();
      });
    },
  },
}
</script>

<style>

</style>
